import { useSnackbar } from "notistack";
import { path, pathOr } from "ramda";
import { useDispatch } from "react-redux";
import { checkTariffExpired } from "root/store/user/userSlice";

import API from "root/js/api";

const WBAPI = new API();

export const errors = {
  does_not_exist: "does_not_exist",
};

export const useFetchErrorHandler = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  //
  return error => {
    const responseStatus = path(["response", "status"], error);
    //
    const message = getMessage(error);
    if (message) return enqueueSnackbar({ message, variant: "error", preventDuplicate: true });
    //
    switch (responseStatus) {
      case 401:
        WBAPI.resetToken();
        history.push(`/signin?redirect_url=${window.location.pathname}?${window.location.search}`);
        break;
      case 429:
        enqueueSnackbar({
          title: "Ошибка",
          message: "Превышен суточный лимит запросов. Вернитесь завтра",
          variant: "error",
          autoHideDuration: 3000,
        });
        break;
      case 403:
        dispatch(checkTariffExpired());
        break;
      default:
        enqueueSnackbar({
          title: "Ошибка",
          message:
            "Что-то пошло не так, пожалуйста, обратитесь в службу поддержки или попробуйте повторить запрос позднее",
          variant: "error",
          preventDuplicate: true,
          autoHideDuration: 3000,
        });
    }
  };
};
// ---------------------- Ошибки конкретных типов
const tokenErrors = {
  ["already_used"]: { message: "Данный токен уже использовался" },
  ["expired"]: { message: "Истёк срок действия введённого токена" },
};
// ---------------------- Обрабатываемые глобально ошибки
const errorsForURLs = {
  ["company/mp_cabinets/callback_wb_oauth/"]: { ["token"]: tokenErrors },
  ["company/mp_cabinets/submit_token_for_demo/"]: { ["token"]: tokenErrors },
  ["company/wb_cabinets/callback_wb_oauth/"]: { ["token"]: tokenErrors },
  ["company/wb_cabinets/submit_token_for_demo/"]: { ["token"]: tokenErrors },
  ["*"]: {
    ["wb_api_key_id"]: {
      ["invalid"]: { message: "Истёк срок действия токена" },
    },
  },
};
//
const getMessage = error => {
  const reqURL = pathOr("", ["response", "request", "responseURL"], error).split("api/")[1];
  //
  const errData = error.response.data || {};
  const errType = Object.keys(errData)[0]; // Тут надо вытащить тип ошибки, например "token"
  const errorCode = errData[errType][0].code;
  //
  return (((errorsForURLs[reqURL] || errorsForURLs["*"] || {})[errType] || {})[errorCode] || {})
    .message;
};
